import * as React from "react";
import { NumericFormat, NumericFormatProps, InputAttributes } from "react-number-format";
// This component not only format units but also remove arrows from textfield type number.
const NumberFormatCustom = React.forwardRef<NumericFormatProps<InputAttributes>>(
  function NumberFormatCustom(props: any, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowNegative={false}
        thousandSeparator
        isNumericString
      />
    );
  },
);

export default NumberFormatCustom;
